<!--suppress UnnecessaryLabelJS -->
<template>
	<page>
		<h1 class="table-title">{{ $t("toolbar.mygames") }}</h1>
		<div class="games-container-outter">
			<div class="games-container-inner px-2 px-md-5 pt-7">
				<h1
					class="assistant text-center mb-3"
					:style="{ direction: isRtl() ? 'rtl' : 'ltr !important' }"
					v-if="!hasGames"
				>
					{{ $t("pages.mygames.firstGame") }}..
				</h1>
				<div class="table-header hidden-sm-and-down" v-else>
					<v-row justify="space-between" align="center" class="headers-row">
						<v-col
							class="
                assistant
                font-weight-bold
                text-center
                white--text
              "
							cols="5"
						>
							<h3>{{ $t("pages.mygames.gameName") }}</h3>
						</v-col>
						<v-col
							class="
                assistant
                font-weight-bold
                text-center
                white--text
              "
							cols="4"
						>
							<h3>{{ $t("pages.mygames.gameType") }}</h3>
						</v-col>
						<v-col
							class="
                assistant
                font-weight-bold
                text-center
                white--text
              "
							cols="3"
						>
							<h3>{{ $t("generics.options") }}</h3>
						</v-col>
					</v-row>
				</div>
				<div class="game-rows-panel">
					<v-row v-for="game in gamesPaginated" :key="game.id" >
						<v-col cols="12">	<game-row
								class="assistant"
								:game="game"
								@share="$emit('share', game)"
								@edit="onEdit"
								@duplicate="duplicate"
							/>
            </v-col>
					</v-row>
				</div>
				<v-row>
					<upgrade-dialog v-model="showUpgrade" />
				</v-row>
				<template v-if="pagination && hasGames">
					<v-row>
						<v-col>
							<v-pagination
								v-model="page"
								v-if="pagination.last_page > 1"
								:length="pagination.last_page"
								@input="changePage"
								color="#ED217C"
							>
							</v-pagination>
						</v-col>
					</v-row>
				</template>
			</div>
		</div>
	</page>
</template>

<script>
import GameRow from "src/view/games/GameRow";
import { types } from "src/store/modules/Game.module";
import FilterAble from "src/mixins/FilterAble";
import UpgradeDialog from "../plans/UpgradeDialog.vue";
import { isRtl } from "src/locales";
export default {
	name: "GamesTable",
	components: {
		GameRow,
		UpgradeDialog,
	},
	props: { public: { default: 0 } },
	// mixins: [new FilterAble(types)],
	data() {
		return {
			chosenImageType: null,
			footerProps: { "items-per-page-options": [10, 20, 50, 100] },
			loading: false,
			headers: [
				{ text: this.$t("generics.name"), value: "name", sortable: false },
				{ text: this.$t("generics.type"), value: "type", sortable: false },
				{
					text: this.$t("generics.actions"),
					value: "actions",
					sortable: false,
				},
			],
			search: null,
			searchText: null,
			chosenTags: [],
			showDialog: false,
			type: "",
			filters: {
				page: 1,
				public: this.public,
			},
			pagination: {},
			page: 1,
			itemsPerPage: 10,
			showUpgrade: false,
      isRtl
		};
	},
	computed: {

		games() {
			const games = this.$store.state.GameModule.games;
			if (games && !Array.isArray(games)) {
				//convert to array in case of object
				return Object.entries(games).map((element) => element[1]);
			}
			return games;
		},
		filterSearch() {
			return this.$store.state.GameModule.filterSearch;
		},
		filterType() {
			return this.$store.state.GameModule.filterType;
		},
		hasGames() {
			return this.games && this.games.length > 0;
		},
		gamesFiltered() {
			let filtered = this.games;
			if (this.type) {
				filtered = filtered.filter((game) => game.type_id === this.type);
			}
			if (this.searchText) {
				filtered = filtered.filter((game) =>
					game.name.includes(this.searchText)
				);
			}

			if (this.chosenTags.length) {
				filtered = filtered.filter((question) => {
					return (
						question.tags &&
						question.tags.filter((tag) => {
							return this.chosenTags.includes(tag.id);
						}).length
					);
				});
			}

			return filtered;
		},
		gamesPaginated() {
			const startIndex = this.itemsPerPage * this.page - this.itemsPerPage;
			return this.gamesFiltered.slice(
				startIndex,
				startIndex + this.itemsPerPage
			);
		},
		canCreateGame() {
			return this.$store.getters.canCreateGame;
		},
		lastPage() {
			return Math.ceil(this.gamesFiltered.length / this.itemsPerPage);
		},
	},
	methods: {
		searchWithCompany(value, search) {
			if (typeof value === "object" && value !== null && value.name) {
				return value.name.indexOf(search) !== -1;
			} else {
				return (
					value != null &&
					search != null &&
					typeof value === "string" &&
					value.toString().indexOf(search) !== -1
				);
			}
		},
		onEdit(Game) {
			this.$emit("edit", Game);
		},
		async duplicate(game) {
			if (this.canCreateGame) {
				let res = await this.$store.dispatch(types.DUPLICATE, game);
				if (res.id) {
					this.$notification.success(this.$t("pages.createGame.duplicate"), "", {
						confirmButtonText: this.$t("generics.accept"),
						cancelButtonText: this.$t("generics.cancel"),
					});
				}
			} else {
				this.showUpgrade = true;
			}
		},
		updateTypeFilter(type) {
			this.type = type.id;
		},
		changePage(page) {
			this.page = page;
		},
		setPagination(
			current_page,
			total,
			last_page,
			first_page_url,
			last_page_url,
			next_page_url,
			from,
			to,
			prev_page_url
		) {
			this.pagination = {
				current_page,
				total,
				last_page,
				first_page_url,
				last_page_url,
				next_page_url,
				from,
				to,
				prev_page_url,
			};
		},
	},

	watch: {
		filterType(type) {
			this.type = type;
		},
		filterSearch(search) {
			this.searchText = search;
		},
		gamesFiltered: function (games) {
			this.changePage(1);
			this.setPagination(
				1,
				games.length,
				this.lastPage,
				"/api/game?page=1",
				"/api/game?page=" + this.lastPage,
				"/api/game?page=2",
				"1",
				"10",
				null
			);
		},
	},
	async created() {
		this.$store.commit(types.SHOW_IN_TOOLBAR, false);
		let res = await this.$store.dispatch(types.FETCH);
		if (res.length == 0 && this.$route.query.init == 1) {
			this.$router.push({name: "types-circles"});
		}
		if (res) {
			delete res.data;
			this.setPagination(
				1,
				res.length,
				this.lastPage,
				"/api/game?page=1",
				"/api/game?page=" + this.lastPage,
				"/api/game?page=2",
				"1",
				"10",
				null
			);
		}
	},
};
</script>

<style>
.game-rows-panel {
  margin-top:-80px;
}

.table-header {
  background-color: #ff9b00;
  border-radius: 19px;
  box-shadow: 0px 0px 9px -3px rgba(0,0,0,0.5) inset;
  padding-bottom:70px;
}

.games-container-outter {
  background-color:rgba(255, 255, 255, 0.3);
  border-radius:25px;
  box-shadow: rgb(100 100 111 / 20%) 0px 0px 14px 3px;
  padding: 10px;
  padding:10px;
  min-height:50vh;
  display: flex;
  flex-direction: column;
}
.games-container-inner {
  background-color:rgba(255, 255, 255, 0.5);
  border-radius:20px;
  height:100%;
  flex-grow: 1;
}
.v-application .text-center {
  text-align: center !important;
}
.headers-row {
  position: relative;
}
.headerCardOrange {
  background-color: #ed217c;
  z-index: 2;
}

.headerCardBlue {
  background-color: #1a1919;
  height: 49px;
  position: absolute;
  left: 0;
}
.headerCardOrange2 {
  background-color: #ed217c;
  z-index: 2;
  left: 30px;
}

.table-title {
  color: white;
  font-size: 3.8rem;
  font-weight: bold;
  text-align: center;
	-webkit-text-stroke: 3px rgba(255,156,0,0.65);
	text-shadow: 0px 2px 9px #282828;
}

@media (max-width: 600px) {
  .game-rows-panel {
    margin-top:0;

  }
}
</style>
